import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { BuzerIcon } from "../../../BuzerIcons";
import { useModalBackClose, useOverlayZ, useScrollLock } from "../hooks";
import { IconButton } from "./IconButton";

// The ONE overlay. Bottom sheet on mobile, centred modal on desktop (same
// anatomy, driven by CSS in primitives.css). Anatomy: drag handle · header
// (icon chip + title + close) · scrolling body · optional sticky footer.
//   icon   — BuzerIcon name (or a node) for the header chip; omit for none
//   footer — node rendered in the sticky footer (e.g. ghost + primary buttons)
// Closes on scrim click, the × button, or Escape.
// full — sheet natiahnutý až po vrch obrazovky (100dvh), ale so zaoblenými vrchnými rohmi
// cardStyle — voliteľný inline štýl na KARTU sheetu (obal hlavičky aj tela). Umožňuje volajúcemu
//   prefarbiť CELÝ sheet (napr. Avatar.tierCardStyle na verejnom profile: farba tieru + biele
//   priesvitné tokeny). Keďže tokeny (--neutral-*, --text…) dedí celý podstrom, hlavička (titul,
//   ×, ghost tlačidlá) sa preklopí na biele. Bez propu = úplne pôvodné správanie (neutrálny sheet).
// className — voliteľné extra triedy na kartu sheetu.
// iconBelow — voliteľný uzol POD veľkou ikonou v hlavičke (v29 §7.2: štítok náročnosti
//   <DifficultyTag> pri detaile návyku aj výzvy). Bez tohto propu je hlavička identická
//   s pôvodnou (ikona ostáva priamym dieťaťom flexu, žiaden obal navyše).
export function Sheet({ title, subtitle, icon, iconBelow, iconStyle, onClose, footer, headerRight, flush = false, center = false, full = false, cardStyle, className = "", children }) {
  useScrollLock(true);
  useModalBackClose(onClose);  // v32.23 — Back closes this sheet instead of navigating away
  const overlayZ = useOverlayZ();  // f-batch #1 — vnorený sheet/modal je vždy NAD tým, z ktorého vzišiel
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose && onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  // v25 §10.14 — keď obsah pretečie (telo by scrollovalo), natiahni sheet na plnú výšku
  const bodyRef = useRef(null);
  const [tall, setTall] = useState(false);
  useEffect(() => {
    const el = bodyRef.current;
    if (el && !tall && el.scrollHeight > el.clientHeight + 4) setTall(true);
  });

  // Portal to <body> so a Sheet opened inside a Modal/transformed card isn't clipped or mis-anchored
  // by an ancestor's overflow:hidden + animation transform (same reason Modal portals) — e.g. the
  // DateField calendar inside the create-challenge form (#2g: couldn't open/close before).
  return createPortal(
    <div className={`bz-scrim${center ? " bz-scrim--center" : ""}`} style={{ "--bz-overlay-z": overlayZ }} onClick={onClose}>
      <div className={`bz-sheet${center ? " bz-sheet--center" : ""}${tall ? " bz-sheet--tall" : ""}${full ? " bz-sheet--full" : ""}${className ? " " + className : ""}`} style={cardStyle} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={typeof title === "string" ? title : undefined}>
        <div className="bz-sheet__head">
          {icon != null && (iconBelow != null ? (
            <span className="bz-sheet__lead">
              <span className="bz-chip" style={iconStyle}>
                {typeof icon === "string" ? <BuzerIcon name={icon} size={18} color="currentColor" /> : icon}
              </span>
              {iconBelow}
            </span>
          ) : (
            <span className="bz-chip" style={iconStyle}>
              {typeof icon === "string" ? <BuzerIcon name={icon} size={18} color="currentColor" /> : icon}
            </span>
          ))}
          {subtitle != null ? (
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="bz-sheet__title" style={{ flex: "none" }}>{title}</div>
              <div className="bz-sheet__subtitle">{subtitle}</div>
            </div>
          ) : (
            <span className="bz-sheet__title">{title}</span>
          )}
          {headerRight}
          <IconButton variant="ghost" size="sm" icon="close" onClick={onClose} aria-label="Zavrieť" />
        </div>
        <div ref={bodyRef} className={`bz-sheet__body${flush ? " bz-sheet__body--flush" : ""}`}>{children}</div>
        {footer && <div className="bz-sheet__foot">{footer}</div>}
      </div>
    </div>,
    document.body);
}
